export const starterCode = `
# This code runs in your browser through Pyodide.
# The last line of the code is displayed as the output of the block.
# See our docs for more details:
# https://docs.supersimple.io/guides/code-blocks/python
`;
